var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6497 1.1499H5.14971C4.0358 1.1499 2.96751 1.5924 2.17986 2.38005C1.39221 3.16771 0.949707 4.23599 0.949707 5.3499V15.8499C0.949707 16.9638 1.39221 18.0321 2.17986 18.8197C2.96751 19.6074 4.0358 20.0499 5.14971 20.0499H15.6497C16.7636 20.0499 17.8319 19.6074 18.6196 18.8197C19.4072 18.0321 19.8497 16.9638 19.8497 15.8499V5.3499C19.8497 4.23599 19.4072 3.16771 18.6196 2.38005C17.8319 1.5924 16.7636 1.1499 15.6497 1.1499Z",
    stroke: "white",
    strokeWidth: 1.575,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3997 14.7999C11.5136 14.7999 12.5819 14.3574 13.3696 13.5698C14.1572 12.7821 14.5997 11.7138 14.5997 10.5999C14.5997 9.48599 14.1572 8.41771 13.3696 7.63005C12.5819 6.8424 11.5136 6.3999 10.3997 6.3999C9.2858 6.3999 8.21751 6.8424 7.42986 7.63005C6.64221 8.41771 6.19971 9.48599 6.19971 10.5999C6.19971 11.7138 6.64221 12.7821 7.42986 13.5698C8.21751 14.3574 9.2858 14.7999 10.3997 14.7999V14.7999Z",
    stroke: "white",
    strokeWidth: 1.575,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.175 5.8749C16.4535 5.8749 16.7205 5.76428 16.9175 5.56736C17.1144 5.37045 17.225 5.10338 17.225 4.8249C17.225 4.54642 17.1144 4.27935 16.9175 4.08244C16.7205 3.88553 16.4535 3.7749 16.175 3.7749C15.8965 3.7749 15.6295 3.88553 15.4325 4.08244C15.2356 4.27935 15.125 4.54642 15.125 4.8249C15.125 5.10338 15.2356 5.37045 15.4325 5.56736C15.6295 5.76428 15.8965 5.8749 16.175 5.8749Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.bc3c021927abbe7bdf13d4feb21ba743.svg";
export { ForwardRef as ReactComponent };